import apiService from '../../services/api'

export default {
	namespaced: true,
	state: {
		modalIsVisible: false,
		promoModalVisible: false,
		upgradeModalVisible: false,
		freezeModalVisible: false,
		showRouters: true,
	},
	getters: {
		modalIsVisible: state => {
			return state.modalIsVisible;
		},
		promoModalVisible: state => {
			return state.promoModalVisible;
		},
		upgradeModalVisible: state => {
			return state.upgradeModalVisible;
		},
		showRouters: state => {
			return state.showRouters;
		},
		freezeModalVisible: state => {
			return state.freezeModalVisible;
		},
	},
	mutations: {
		updateModalVisibility(state, value) {
			state.modalIsVisible = value;
		},
		updatePromoModalVisibility(state, value) {
			state.promoModalVisible = value
		},
		updateUpgradeModalVisibility(state, value) {
			state.upgradeModalVisible = value
		},
		updateShowRouters(state, value) {
			state.showRouters = value
		},
		updateFreezeModalVisibility(state, value) {
			state.freezeModalVisible = value
		},
	},
	actions: {

	}
}
